import { format } from 'date-fns'
import {
  PiStethoscopeDuotone,
  PiHourglassSimpleHighFill,
  PiSealCheckFill,
} from 'react-icons/pi'
import { BsFillPersonCheckFill } from 'react-icons/bs'
import { FaRegCheckCircle } from 'react-icons/fa'

const returnColor = (tpEstado) => {
  switch (tpEstado) {
    case '1':
      return '#d4d672' // Verde Claro
    case '2':
      return '#2893B5' // Azul
    case '3':
      return '#d91414' // Vermelho
    case '5':
      return '#1a9042' // Verde Escuro
    case '6':
      return '#f9f9f9' // Cinza Claro
    default:
      return '#757575' // Cinza
  }
}

const returnFontColor = (tpEstado) => {
  switch (tpEstado) {
    case '1':
      return '#676767' // Cor para o estado 'cancelado'
    case '6':
      return '#999' // Cor para o estado 'cancelado'
    default:
      return 'white'
  }
}

export const EventRender = ({ event }) => {
  return (
    <div className="flex items-center bg-[#b6d3c9] h-full justify-between px-3 py-2 rounded-lg shadow-md mt-[-5px]">
      {/* Informações do Evento */}
      <div className="w-5/12 flex flex-col">
        <p className="font-semibold text-black truncate">{event.data?.[3]}</p>
        <p className="text-black text-[0.75rem]">
          {format(new Date(event.start), 'HH:mm')} às{' '}
          {format(new Date(event.end), 'HH:mm')}
        </p>
      </div>

      {/* Tipo de Agendamento */}
      <div className="w-1/6 hidden sm:block">
        <p className="text-black text-[0.75rem]">
          {event.data?.[6]?.dsTipoAgendamento}
        </p>
      </div>

      {/* Segundo Tipo de Agendamento */}
      <div className="w-1/6 hidden sm:block">
        <p className="text-black text-[0.75rem]">
          {event.data?.[4]?.dsTipoAgendamento}
        </p>
      </div>

      {/* Estado do Agendamento */}
      <div className="w-1/6 flex items-center justify-center">
        {event.data?.[8] == null ? (
          <div
            className="flex items-center justify-center text-white py-1 px-2 rounded-full"
            style={{
              backgroundColor: returnColor(event.data?.[5]?.tpEstado),
              marginRight: 10,
              width: 150,
            }}
          >
            {event.data?.[5]?.tpEstado === '1' && (
              <PiHourglassSimpleHighFill
                className="mr-1"
                style={{ color: '#676767' }}
              />
            )}
            {event.data?.[5]?.tpEstado === '2' && (
              <PiSealCheckFill className="mr-1" />
            )}
            {event.data?.[5]?.tpEstado === '3' && (
              <PiStethoscopeDuotone className="mr-1" />
            )}
            {event.data?.[5]?.tpEstado === '5' && (
              <BsFillPersonCheckFill className="mr-1" />
            )}
            {event.data?.[5]?.tpEstado === '6' && (
              <FaRegCheckCircle className="mr-1" style={{ color: '#999' }} />
            )}
            <p
              className="text-sm"
              style={{
                color: returnFontColor(event.data?.[5]?.tpEstado),
              }}
            >
              {event.data?.[5]?.dsEstado}
            </p>
          </div>
        ) : (
          <div
            className="flex items-center justify-center text-white py-1 px-3 rounded-full"
            style={{
              backgroundColor: '#d0d0d0',
              marginRight: 10,
            }}
          >
            {event.data?.[5]?.tpEstado === '1' && (
              <PiHourglassSimpleHighFill
                className="mr-1"
                style={{ color: '#676767' }}
              />
            )}
            {event.data?.[5]?.tpEstado === '2' && (
              <PiSealCheckFill className="mr-1" />
            )}
            {event.data?.[5]?.tpEstado === '3' && (
              <PiStethoscopeDuotone className="mr-1" />
            )}
            {event.data?.[5]?.tpEstado === '5' && (
              <BsFillPersonCheckFill className="mr-1" />
            )}
            {event.data?.[5]?.tpEstado === '6' && (
              <FaRegCheckCircle className="mr-1" style={{ color: '#999' }} />
            )}
            <p
              className="text-sm"
              style={{
                color: returnFontColor(event.data?.[5]?.tpEstado),
              }}
            >
              Cancelado
            </p>
          </div>
        )}
      </div>
    </div>
  )
}
